import React from "react";
import { Button, Card, Stack } from "react-bootstrap";
import { copyToClipboard } from "../../../../utils/copyToClipboard";

const ShareQRCode = ({ title, url, inviteLink }) => {
  const handleDownload = () => {
    if (url) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "qr-code.jpg";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error downloading the image:", error));
    }
  };

  return (
    <Card className="dashboard_cards h-100" style={{ border: "none" }}>
      <Card.Body>
        <Card.Title
          style={{ fontSize: 20, fontWeight: "500" }}
          className="d-flex gap-2 text_gray flex-wrap mb-3"
        >
          {title}
        </Card.Title>
        {url ? (
          <Stack direction="horizontal" className="gap-2 flex-wrap">
            <Stack className="gap-2">
              <Button
                className="flex-grow-1"
                onClick={() => copyToClipboard(inviteLink || url)}
              >
                Copy Invitation Link
              </Button>
              <Button className="flex-grow-1" onClick={handleDownload}>
                Download QR Code
              </Button>
            </Stack>
            <div className="position-relative justify-content-center align-items-end d-flex">
              <div style={{ width: "114px", height: "120px" }}>
                <img
                  src={url}
                  alt="user-icon"
                  width={114}
                  height={120}
                  className="w-100 h-100 object-fit-contain"
                />
              </div>
            </div>
          </Stack>
        ) : (
          <h6>No QR code found</h6>
        )}
      </Card.Body>
    </Card>
  );
};

export default ShareQRCode;
